import React, { useEffect, useCallback, useRef } from "react";
import { Field } from "formik";
import { useDropzone } from "react-dropzone";
import { IoIosCloseCircle } from "react-icons/io";
import get from "lodash/get";
import {
  Flex,
  Text,
  Input,
  Spacer,
  Icon,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from "@chakra-ui/react";
import ExtensionIcon from "../ExtensionIcon";

const CustomDropzone = ({
  title,
  fieldName,
  height,
  maxFiles,
  setAnexoNaoEditado,
  formProps,
  maxTextWidth,
  heightImage,
  isDisabled,
  titleText,
  whiteSpace,
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    maxFiles: maxFiles ? maxFiles : 1,
  });
  const formPropsRef = useRef(formProps);

  useEffect(() => {
    formPropsRef.current = formProps;
  }, [formProps]);

  const updateFieldValue = useCallback(() => {
    if (acceptedFiles.length > 0) {
      formPropsRef.current.setFieldValue(fieldName, acceptedFiles[0]);
    }
  }, [acceptedFiles, fieldName]);

  useEffect(() => {
    updateFieldValue();
  }, [updateFieldValue]);

  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        const errorMessage = get(form.errors, fieldName);
        const isError = !!errorMessage && get(form.touched, fieldName);

        return (
          <FormControl
            isInvalid={isError}
            id={fieldName}
            height="100%"
            d="flex"
            flexDir="column"
          >
            <FormLabel
              color="#5F6377"
              fontWeight="500"
              fontSize="14px"
              lineHeight="19.6px"
              htmlFor={fieldName}
              whiteSpace={whiteSpace ? "nowrap" : "normal"}
            >
              {title}
            </FormLabel>
            {field.value ? (
              <Flex
                id={fieldName}
                width={"216px"}
                borderRadius="24px"
                flex={height === "auto" ? "1" : null}
                height={{ base: "auto", lg: height ? height : "42px" }}
                backgroundColor="#E3E3E3"
                alignItems="center"
                justifyContent="center"
                p={
                  height
                    ? Number(height.substring(0, height.length - 2)) < 80
                      ? "6px"
                      : "1px"
                    : "1px"
                }
              >
                <Flex
                  h={heightImage ? heightImage : "100%"}
                  w="30px"
                  ml={"10px"}
                >
                  <ExtensionIcon path={field.value.name} />
                </Flex>
                <Flex
                  flexDir="column"
                  maxW={{ base: "50%", lg: "70%" }}
                  ml="10px"
                >
                  <Text
                    fontWeight="600"
                    fontSize="14px"
                    lineHeight="13px"
                    color="#1A203D"
                    title={field.value.name}
                    wordBreak="break-word"
                    noOfLines={2}
                  >
                    {height
                      ? Number(height?.substring(0, height?.length - 2)) === 120
                        ? field?.value?.name?.length > 50
                          ? field?.value?.name?.substring(0, 50) + "..."
                          : field?.value?.name
                        : field?.value?.name?.length > 25
                        ? field?.value?.name?.substring(0, 25) + "..."
                        : field?.value?.name
                      : field?.value?.name?.length > 25
                      ? field?.value?.name?.substring(0, 25) + "..."
                      : field?.value?.name}
                  </Text>
                  <Text
                    fontWeight="600"
                    fontSize="12px"
                    lineHeight="13px"
                    color="#5F6377"
                  >
                    {(Number(field.value.size) / 1000).toFixed(2)} kB
                  </Text>
                </Flex>
                <Spacer />

                <Icon
                  aria-label="Excluir arquivo"
                  color="#9EA1AE"
                  as={IoIosCloseCircle}
                  boxSize="40px"
                  _hover={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!isDisabled) {
                      formProps.setFieldValue(fieldName, null);
                      if (setAnexoNaoEditado) {
                        setAnexoNaoEditado();
                      }
                    }
                  }}
                />
              </Flex>
            ) : isDisabled ? (
              <Flex
                id={fieldName}
                width={"216px"}
                minH="42px"
                borderRadius="24px"
                flex={{ base: null, lg: height === "auto" ? "1" : null }}
                height={{ base: "42px", lg: height ? height : "42px" }}
                backgroundColor="#E3E3E3"
                alignItems="center"
                justifyContent="center"
                cursor={"pointer"}
                title={titleText}
              >
                <Text
                  fontWeight="600"
                  fontSize="14px"
                  lineHeight="19.6px"
                  color="#5F6377"
                >
                  Procure seu Arquivo
                </Text>
              </Flex>
            ) : (
              <Flex
                id={fieldName}
                width={"216px"}
                minH="42px"
                borderRadius="24px"
                flex={{ base: null, lg: height === "auto" ? "1" : null }}
                height={{ base: "42px", lg: height ? height : "42px" }}
                backgroundColor="#E3E3E3"
                alignItems="center"
                justifyContent="center"
                cursor={"pointer"}
                {...getRootProps()}
              >
                <Input {...getInputProps()} />
                <Text
                  fontWeight="600"
                  fontSize="14px"
                  lineHeight="19.6px"
                  color="#5F6377"
                >
                  Procure seu Arquivo
                </Text>
              </Flex>
            )}
            {isError && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
          </FormControl>
        );
      }}
    </Field>
  );
};

export default CustomDropzone;
